export default __webpack_public_path__ + "static/media/Sophia_9781408303535.567e86dd.jpg";